import PatientReport from './PatientReport';

export default PatientReport;
